module.exports = {
      id: "icon-calendar-clock-usage",
      viewBox: "0 0 57 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-calendar-clock",
      toString: function () {
        return this.url;
      }
    }